import * as React from "react";
import {DraggableProvided, DraggableStateSnapshot} from "react-beautiful-dnd";
import {Table} from "semantic-ui-react";
import {CategoryTextSortDto} from "../../../services/Client";

interface ICategorySortTableRowProps {
    provided: DraggableProvided;
    snapshot: DraggableStateSnapshot;
    row: CategoryTextSortDto[];
    index: number;
}

export const CategorySortTableRow: any = (props: ICategorySortTableRowProps) => {

    function renderGroupedCells(value: any) {
        return (props.row.length > 1 ? <Table.Cell rowSpan={props.row.length}>{value}</Table.Cell> : <Table.Cell>{value}</Table.Cell>);
    }

    return (
        <>
            {
                props.row.map(row => {
                    return (
                        <>
                            <tr
                                key={props.row[0].proMTSequence}
                                ref={props.provided.innerRef}
                                {...props.provided.draggableProps}
                                {...props.provided.dragHandleProps}
                                style={{
                                    userSelect: "none",
                                    background: props.snapshot.isDragging ? "#880505bd" : props.index % 2 === 0 ? 'white' : '#80808029',
                                    display: props.snapshot.isDragging ? 'inline-table' : '',
                                    ...props.provided.draggableProps.style
                                }}
                            >
                                {
                                    props.snapshot.isDragging
                                        ? <>
                                            <Table.Cell>{row.textDE}</Table.Cell>
                                            <Table.Cell>{row.textEN}</Table.Cell>
                                            <Table.Cell>{row.proMTSequence}</Table.Cell>
                                        </>
                                        : <>
                                            <Table.Cell>{row.categoryCode}</Table.Cell>
                                            {props.row.indexOf(row) === 0 && renderGroupedCells(row.textDE)}
                                            {props.row.indexOf(row) === 0 && renderGroupedCells(row.textEN)}
                                            <Table.Cell>{row.sequenceNo}</Table.Cell>
                                            {props.row.indexOf(row) === 0 && renderGroupedCells(row.proMTSequence)}
                                        </>
                                }
                            </tr>
                        </>);
                })
            }
        </>
        );

};



// WEBPACK FOOTER //
// ./src/views/AdminView/CategorySortTab/CategorySortTableRow.tsx